import React, { useState, useEffect } from 'react';
import axios from 'axios';
import OknoUmawianiaPrzegladu from './przeglady/OknoUmawianiaPrzegladu';
import './componenetStyle/Przeglady.css';

const API_URL = process.env.REACT_APP_API_URL;

function Przeglady({ uzytkownik }) {
  const [clients, setClients] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [sortField, setSortField] = useState('');
  const [sortOrder, setSortOrder] = useState('ASC');
  const [selectedClient, setSelectedClient] = useState(null);
  const [showUmawianie, setShowUmawianie] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [totalPages, setTotalPages] = useState(1);

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const refreshClients = async () => {
    try {
      const resp = await axios.get(`${API_URL}/klienci`, {
        headers,
        params: {
          page,
          limit,
          search: searchTerm || undefined,
          sortField: sortField || undefined,
          sortOrder
        }
      });
      const { klienci: clientsData, totalPages } = resp.data;
      setTotalPages(totalPages);

      const addressPromises = clientsData.map(cli =>
        axios.get(`${API_URL}/adresy`, {
          headers,
          params: { id_klient: cli.id_klient }
        })
      );
      const addressResponses = await Promise.all(addressPromises);

      const devicesRes = await axios.get(`${API_URL}/urzadzenia`, { headers });
      const devicesData = devicesRes.data;

      const clientsWithAll = clientsData.map((cli, idx) => {
        const adresy = addressResponses[idx].data.map(ad => ({
          ...ad,
          urzadzenia: devicesData.filter(dev => dev.id_adres === ad.id_adres)
        }));
        return { ...cli, adresy };
      });

      setClients(clientsWithAll.filter(cli => !cli.rezygnacja_z_przegladow));
    } catch (err) {
      console.error("Błąd pobierania danych:", err);
    }
  };

  useEffect(() => {
    refreshClients();
  }, [token, page, limit, searchTerm, sortField, sortOrder]);

  const handleSort = col => {
    if (sortField === col) {
      setSortOrder(o => (o === 'ASC' ? 'DESC' : 'ASC'));
    } else {
      setSortField(col);
      setSortOrder('ASC');
    }
    setPage(1);
  };

  const handleSearch = () => {
    setPage(1);
    setSearchTerm(searchInput.trim());
  };

  const handleUmow = client => {
    setSelectedClient(client);
    setShowUmawianie(true);
  };

  return (
    <div className="przeglady-container">
      <h2>Przeglądy</h2>

      <div className="pagination-controls">
        <div className="limit-controls">
          Pokaż na stronie:&nbsp;
          {[20, 50, 100].map(n => (
            <button
              key={n}
              onClick={() => { setLimit(n); setPage(1); }}
              className={limit === n ? 'selected' : ''}
            >
              {n}
            </button>
          ))}
        </div>
        <div className="pagination-arrows">
          <button
            onClick={() => page > 1 && setPage(page - 1)}
            disabled={page === 1}
          >
            ‹
          </button>
          <span> {page} / {totalPages} </span>
          <button
            onClick={() => page < totalPages && setPage(page + 1)}
            disabled={page === totalPages}
          >
            ›
          </button>
        </div>
      </div>

      <div style={{ margin: '1em 0' }}>
        <input
          type="text"
          placeholder="Szukaj przeglądów..."
          value={searchInput}
          onChange={e => setSearchInput(e.target.value)}
        />
        <button onClick={handleSearch}>Szukaj</button>
      </div>

      <table className="przeglady-table">
        <thead>
          <tr>
            <th onClick={() => handleSort('imie')} className="sortable">
              Imię {sortField === 'imie' ? (sortOrder === 'ASC' ? '▲' : '▼') : '⇅'}
            </th>
            <th onClick={() => handleSort('nazwisko')} className="sortable">
              Nazwisko {sortField === 'nazwisko' ? (sortOrder === 'ASC' ? '▲' : '▼') : '⇅'}
            </th>
            <th>Telefon</th>
            <th>Email</th>
            <th onClick={() => handleSort('adres')} className="sortable">
              Adres {sortField === 'adres' ? (sortOrder === 'ASC' ? '▲' : '▼') : '⇅'}
            </th>
            <th onClick={() => handleSort('kontakt')} className="sortable">
              Kontakt {sortField === 'kontakt' ? (sortOrder === 'ASC' ? '▲' : '▼') : '⇅'}
            </th>
            <th>Cel kontaktu</th>
            <th onClick={() => handleSort('grupa_kliencka')} className="sortable">
              Grupa kliencka {sortField === 'grupa_kliencka' ? (sortOrder === 'ASC' ? '▲' : '▼') : '⇅'}
            </th>
            <th>Akcje</th>
          </tr>
        </thead>
        <tbody>
          {clients.map(client => (
            <tr key={client.id_klient}>
              <td>{client.imie}</td>
              <td>{client.nazwisko}</td>
              <td>{client.nr_telefonu || '-'}</td>
              <td>{client.adres_email || '-'}</td>
              <td>
                {client.adresy.length
                  ? client.adresy
                      .map(a => `${a.miasto}, ${a.ulica} ${a.nr_domu}${a.nr_lokalu ? ' lok. ' + a.nr_lokalu : ''}`)
                      .join('; ')
                  : '-'}
              </td>
              <td>
                {client.kontakt
                  ? new Date(client.kontakt).toLocaleDateString()
                  : '-'}
              </td>
              <td>{client.cel_kontaktu || '-'}</td>
              <td>{client.grupa_kliencka || '-'}</td>
              <td>
                <button onClick={() => handleUmow(client)}>Umów</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showUmawianie && selectedClient && (
        <OknoUmawianiaPrzegladu
          klient={selectedClient}
          uzytkownik={uzytkownik}
          onClose={() => {
            setShowUmawianie(false);
            refreshClients();
          }}
        />
      )}
    </div>
  );
}

export default Przeglady;
